import { useTranslation } from 'react-i18next';

export function MissionSection() {
  const { t } = useTranslation();

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="bg-gray-800 rounded-2xl border border-gray-700 p-8 sm:p-10 lg:p-12 shadow-2xl">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 flex items-center justify-center bg-yellow-400/10 rounded-full">
              <i className="ri-bullseye-line text-4xl text-yellow-400"></i>
            </div>
          </div>
          
          <div className="space-y-6 text-center">
            <p className="text-gray-300 text-lg leading-relaxed">
              {t('about.opening.paragraph1')}
            </p>
            <p className="text-yellow-400 text-2xl font-bold">
              {t('about.opening.paragraph2')}
            </p>
            <p className="text-gray-300 text-lg leading-relaxed">
              {t('about.opening.paragraph3')}
            </p>
            <p className="text-white text-xl sm:text-2xl font-semibold leading-relaxed border-l-4 border-yellow-400 pl-6 text-left max-w-3xl mx-auto">
              {t('about.opening.mission')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
